export const ANALYTICS_EVENTS = {
  PAGE_VIEWED: 'Page Viewed',
  PAGE_EXITED: 'Page Exited',
  CAMPAIGN_CREATED: 'Campaign Created',
  CAMPAIGN_SUBMITTED: 'Campaign Submitted',
  CAMPAIGN_STATUS_CHANGED: 'Campaign Status Changed',
  REPORT_EXPORTED: 'Report Exported',
  LOGIN_STARTED: 'Login Started',
  LOGIN_COMPLETED: 'Login Completed',
  LOGIN_FAILED: 'Login Failed',
  RAGE_CLICK_DETECTED: 'Rage Click Detected',
  LINE_ITEM_CREATED: 'Line Item Created',
  LINE_ITEM_SUBMITTED: 'Line Item Submitted',
  CREATIVE_UPLOADED: 'Creative Uploaded',
  CREATIVE_SUBMITTED: 'Creative Submitted',
  CREATIVE_REJECTED: 'Creative Rejected',
  ASSET_UPLOADED: 'Asset Uploaded',
  CONTENT_PACKAGE_BROWSED: 'Content Package Browsed',
  CONTENT_PACKAGE_SELECTED: 'Content Package Selected',
  BUDGET_ENTERED: 'Budget Entered',
  LINE_ITEM_NAME_ENTERED: 'LineItem Name Entered',
  LINE_ITEM_START_DATE_ENTERED: 'Start Date Entered',
  LINE_ITEM_END_DATE_ENTERED: 'End Date Entered',
  GENDER_SELECTED: 'Gender Selected',
  AGE_GROUPS_SELECTED: 'Age Groups Selected',
  DEVICE_TARGETING_SELECTED: 'Device Targeting Selected',
  AD_LENGTH_SELECTED: 'Ad Length Selected',
  INVENTORY_CHECK_PERFORMED: 'Inventory Check Performed',
  ERROR_OCCURRED: 'Error Occurred',
  VALIDATION_ERROR_SHOWN: 'Validation Error Shown',
  FORM_FIELD_INTERACTION: 'Form Field Interaction',
  TOOLTIP_VIEWED: 'Tooltip Viewed',
  CAMPAIGN_FORM_ELEMENT_CLICKED: 'Form Element Clicked',
  LOW_INVENTORY_WARNING: 'Low Inventory Warning',
  BASE_TARGETING_APPLIED: 'Base Targeting Applied',
  AUDIENCE_SELECTED: 'Audience Selected',
  GENRE_SELECTED: 'Genre Selected',
  LOCATION_SELECTED: 'Location Selected',
  PREMIUM_CONTENT_TARGETING: 'Premium Content Targeting',
  AD_FORMAT_SELECTED: 'Ad Format Selected',
  DELIVERY_ADS_APPLIED: 'Delivery Ads Applied',
  POST_SUBMIT_EDIT: 'Post Submit Edit',
  POST_LAUNCH_BUDGET_EDIT: 'Launch Budget Edit',
  POST_LAUNCH_DATE_EDIT: 'Launch Date Edit',
  POST_LAUNCH_TARGETING_EDIT: 'Launch Targeting Edit',
  POST_LAUNCH_CREATIVE_SWAP: 'Launch Creative Swap',
} as const;

export type AnalyticsEventName = (typeof ANALYTICS_EVENTS)[keyof typeof ANALYTICS_EVENTS];
